var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// Component to show a field for display (view, edit & list)
import React, { memo, useState } from "react";
import "./fields";
import fieldsDictionary from "@/components/fields/fieldsDictionary";
import { useLogger } from "@/utils/loggerService";
import { FieldViewType, screenViewType } from "./viewType";
import { fieldsType } from "@/utils/types/field";
import { faPen } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
//import { useGetEmailsQuery } from "@/store/api";
/**
 * <b>Composant qui utilise la bibliothèque de champs pour transmettre le rendu au champ approprié avec tous ses paramètres.</b>
 *
 * @description This component uses the field library to pass the rendering to the appropriate field with all its parameters.
 *
 * @param {DisplayFieldProps} props
 * @returns
 */
function DisplayField(_a) {
    var moduleName = _a.moduleName, fieldName = _a.fieldName, fieldLabel = _a.fieldLabel, record = _a.record, labelClassName = _a.labelClassName, className = _a.className, fieldDef = _a.fieldDef, componentClassName = _a.componentClassName, fieldClassName = _a.fieldClassName, _b = _a.viewType, viewType = _b === void 0 ? FieldViewType.DETAIL : _b, hideLabel = _a.hideLabel, disabledLabel = _a.disabledLabel, separatorIndicator = _a.separatorIndicator, fieldMetadata = _a.fieldMetadata, handleEdit = _a.handleEdit, onUpdate = _a.onUpdate, validations = _a.validations, _c = _a.isEditable, isEditable = _c === void 0 ? true : _c, _d = _a.viewScreen, viewScreen = _d === void 0 ? screenViewType.DETAILVIEW : _d, _e = _a.showEditButton, showEditButton = _e === void 0 ? true : _e, _f = _a.isOnStudio, isOnStudio = _f === void 0 ? false : _f, _g = _a.isReport, isReport = _g === void 0 ? false : _g;
    var logger = useLogger().logger;
    var fieldType = (fieldMetadata.type || "base").toLowerCase();
    var fieldGroup = fieldMetadata === null || fieldMetadata === void 0 ? void 0 : fieldMetadata.group;
    if (fieldName === "email1") {
        fieldType = fieldsType.email;
    }
    if (fieldType === "url") {
        fieldType = fieldsType.link;
    }
    if (fieldType === "datetimecombo") {
        fieldType = fieldsType.datetime;
    }
    if (fieldType === "radioenum") {
        fieldType = fieldsType.radio;
    }
    if (fieldType === "dynamicenum") {
        fieldType = fieldsType.enum;
    }
    if (fieldGroup && fieldGroup.includes("address")) {
        fieldType = fieldsType.address;
    }
    if (fieldMetadata.name === "photo" || fieldType === "image") {
        fieldType = fieldsType.file;
    }
    if (fieldMetadata.name === "name") {
        fieldType = fieldsType.name;
    }
    /*const { data: listEmails } = useGetEmailsQuery({
      recordId: record.id,
      moduleName: moduleName,
    });
    const loadEmails = () => {
      const defaultEmails = listEmails?.data?.prefillData;
      record.email1 = defaultEmails;
    };
  
    if (fieldName === "email1") {
      loadEmails();
    }*/
    //const fieldType = fieldMetadata;
    var fieldComponent = fieldsDictionary.getField(viewType, fieldType || fieldsType.base)
        ? fieldsDictionary.getField(viewType, fieldType)
        : fieldsDictionary.getField(viewType, fieldsType.base);
    if (fieldName && !fieldType) {
        logger.error("[FIELD] - Pas de type de champ renseign\u00E9 pour le champ ".concat(fieldName, " du module ").concat(moduleName));
    }
    if (fieldComponent !== undefined) {
        logger.debug("[FIELD] - Utilisation du composant ".concat(fieldComponent.name, " pour afficher le champ ").concat(fieldName, "(").concat(fieldType, ") de la vue ").concat(viewType));
    }
    var _h = useState(false), isHover = _h[0], setIsHover = _h[1];
    var handleMouseOver = function () {
        setIsHover(true);
    };
    var handleMouseOut = function () {
        setIsHover(false);
    };
    return (_jsx("div", __assign({ className: "flex flex-col w-full" }, { children: _jsxs("div", __assign({ className: "flex flex-col w-full flex-wrap items-left ".concat(className || "", " ") }, { children: [!hideLabel && (_jsxs("label", __assign({ className: "first-letter:capitalize ".concat(labelClassName || "", " ").concat(disabledLabel
                        ? "text-[var(--label-disabled-color)]"
                        : "text-[var(--colors-label)]", " "), onMouseOver: handleMouseOver, onMouseOut: handleMouseOut }, { children: [fieldLabel, fieldMetadata && fieldMetadata["required"] && (_jsx("span", __assign({ className: "pl-1 text-[rgb(var(--color-red-500))]" }, { children: "*" }))), _jsx("span", __assign({ className: "mx-1" }, { children: separatorIndicator })), viewScreen !== screenViewType.EDITVIEW &&
                            isHover &&
                            !isNewRecord(record) &&
                            showEditButton &&
                            fieldType !== "fullname" &&
                            fieldMetadata.inline_edit !== false &&
                            fieldType !== "function" && (_jsx("button", __assign({ className: "mr-2", onClick: function () {
                                handleEdit(true);
                            }, title: "Editer" }, { children: _jsx(FontAwesomeIcon, { icon: faPen, className: "text-gray-400 pl-1" }) })))] }))), fieldComponent &&
                    React.createElement(fieldComponent, {
                        moduleName: moduleName,
                        fieldName: fieldName,
                        fieldDef: fieldDef,
                        record: record,
                        componentClassName: componentClassName,
                        fieldClassName: fieldClassName,
                        className: className,
                        fieldLabel: fieldLabel,
                        labelClassName: labelClassName,
                        viewType: viewType,
                        fieldMetadata: fieldMetadata,
                        onUpdate: onUpdate,
                        validations: validations,
                        isOnStudio: isOnStudio,
                        isReport: isReport,
                    }), validations && (_jsx("ul", { children: (validations.get(fieldName) || []).map(function (v, index) { return (_jsxs("li", __assign({ className: "text-[rgb(var(--color-red-500))] text-center text-sm font-medium" }, { children: [_jsx(FontAwesomeIcon, { icon: "triangle-exclamation" }), " ", fieldLabel, _jsx("span", __assign({ className: "p-1" }, { children: v }))] }), index)); }) }))] })) })));
}
/**
 * Check if is a new record
 */
export function isNewRecord(record) {
    var isNewRecord = false;
    if (record && record.id === "") {
        isNewRecord = true;
    }
    else if (!record || !record.id) {
        isNewRecord = true;
    }
    else if (record && record.new_with_id) {
        isNewRecord = true;
    }
    return isNewRecord;
}
export default memo(DisplayField);
